import store from "../store-root";
import api from "../../service/api";
import queryString from "querystring";

const moduleName = "costOriginValue";

store.registerModule(moduleName, {
  namespaced: true,
  actions: {
    //查询资产计提
    async getAssetsCalculationList({ commit }, payload) {
      let result = await api.get(
        `/api/AssetCost/Get?${queryString.stringify(payload)}`
      );
      return result.data;
    },
    //计提
    async jiti({ commit }, payload) {
      let result = await api.get(
        `/api/AssetCost/Proviston?${queryString.stringify(payload)}`
      );
      return result;
    },
    //获取资产原值列表;
    async getCostOriginValueList({ commit }, payload) {
      let result = await api.get(
        `/api/AssetCost/GetPage?${queryString.stringify(payload)}`
      );
      return result.data;
    },
    // 添加资产原值
    async addCostOriginValue({ commit }, payload) {
      let result = await api.post("/api/AssetCost/Add", payload);
      return result;
    },
    // 删除资产原值
    async deleteCostOriginValue({ commit }, payload) {
      let result = await api.delete(`/api/AssetCost/id?id=${payload}`);
      return result;
    },
    // 更新资产原值数据
    async updateCostOriginValue(bb, payload) {
      let result = await api.put(
        `/api/AssetCost/id?id=${payload.id}`,
        payload.obj
      );
      return result;
    }
  }
});

export default moduleName;
